import {ProjectAccessMode} from "../project/types"
import {accessOptions} from "./const"
import ApiProject from "../../gd/api/project"
import {SESSION_PROJECT_CHANGE} from "../../gd/bus/bus-event-type"

type TagAccessModel = {
    parentId?   : ID | null
    accessMode? : ProjectAccessMode
}

function isPublicAccessMode(accessMode?: ProjectAccessMode): boolean {
    return accessMode === ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN
        || accessMode === ProjectAccessMode.PUBLIC_INHERITANCE_NONE
}

// shared and private are both stored as INHERITANCE_PARENT_CHILDREN, they differ only by the users number
export function getTagAccessMode(projectId: ID, accessMode: ProjectAccessMode): ProjectAccessMode {
    if (isPublicAccessMode(accessMode)) {
        return ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN
    }

    if (accessMode === ProjectAccessMode.TAG_SHARED) {
        return accessMode
    }

    const usersNumber = gd.session.projectUsers.notClients(projectId).length

    return usersNumber <= 1 ? ProjectAccessMode.INHERITANCE_PARENT_CHILDREN : ProjectAccessMode.TAG_SHARED
}

// Option values are the accessOptions ids: PUBLIC (3), TAG_SHARED (2), private INHERITANCE_PARENT_CHILDREN (1).
// Mode 2 is never stored - shared and private differ only by the users number, see getTagAccessMode.
export function getTagAccessOptions(project?: TagAccessModel, forEdit = false): Option[] {
    const options = _.map(accessOptions, option => {
        return {
            label       : option.label,
            value       : option.id,
            description : option.description,
            icon        : option.icon,
        }
    })

    // project tags inherit parent users - they can not become public (but can already be one)
    if (
        forEdit
        && project?.parentId
        && !isPublicAccessMode(project.accessMode)
    ) {
        return _.filter(options, option => {
            return option.value !== ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN
        })
    }

    return options
}

// public tags hold every company user - a user can only be removed once the tag is shared (stored INHERITANCE_PARENT_CHILDREN)
export async function makePublicTagShared(projectId: ID) {
    const project = gd.session.projects.get(projectId)

    if (
        !project?.isTag
        || !isPublicAccessMode(project.accessMode)
    ) {
        return
    }

    const oldAccessMode = project.accessMode

    // show shared right away - SESSION_PROJECT_CHANGE re-renders the project info users section
    project.accessMode = ProjectAccessMode.INHERITANCE_PARENT_CHILDREN
    gd.bus.triggerEvent(SESSION_PROJECT_CHANGE, projectId)

    try {
        await ApiProject.updateNew(projectId, {
            accessMode  : ProjectAccessMode.INHERITANCE_PARENT_CHILDREN
        }).promise()
    } catch (e) {
        project.accessMode = oldAccessMode
        gd.bus.triggerEvent(SESSION_PROJECT_CHANGE, projectId)

        // callers must not remove the user from a tag that is still public
        throw e
    }
}
